// src/pages/attendance/components/WFHModal.jsx
import React from "react";
import { Home, X } from "lucide-react";
import DatePicker from "../../../components/DatePicker";

const WFHModal = ({ show, onClose, wfhDate, setWfhDate, wfhReason, setWfhReason, isSubmittingWFH, onSubmit, t, currentTheme, isDarkMode, language }) => {
  if (!show) return null;
  const c = currentTheme.colors;

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, padding: "20px" }}>
      <div style={{ background: isDarkMode ? "linear-gradient(135deg,rgba(30,41,59,0.98),rgba(15,23,42,0.98))" : "linear-gradient(135deg,rgba(255,255,255,0.98),rgba(248,250,252,0.98))", borderRadius: "24px", padding: "32px", width: "100%", maxWidth: "480px", boxShadow: isDarkMode ? "0 25px 50px rgba(0,0,0,0.5)" : "0 25px 50px rgba(0,0,0,0.15)", border: `1px solid ${isDarkMode ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)"}`, direction: language === "ar" ? "rtl" : "ltr" }}>

        {/* header */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "24px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <div style={{ width: "48px", height: "48px", borderRadius: "12px", background: `${c.primary}15`, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Home size={24} color={c.primary} />
            </div>
            <h2 style={{ margin: 0, fontSize: "20px", fontWeight: "700", color: c.textPrimary, fontFamily: "'Cairo', sans-serif" }}>{t.workFromHome.modalTitle}</h2>
          </div>
          <button onClick={onClose} style={{ background: "transparent", border: "none", cursor: "pointer", padding: "8px", borderRadius: "8px", display: "flex" }}>
            <X size={24} color={c.textMuted} />
          </button>
        </div>

        {/* date */}
        <div style={{ marginBottom: "20px" }}>
          <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "600", color: c.textSecondary, fontFamily: "'Cairo', sans-serif" }}>{t.workFromHome.selectDate}</label>
          <DatePicker
            theme={isDarkMode ? "dark" : "light"}
            isRTL={language === "ar"}
            value={wfhDate}
            onChange={(v) => setWfhDate(v)}
            minDate={new Date().toISOString().split("T")[0]}
            buttonStyle={{ width: "100%", padding: "14px 16px", borderRadius: "12px", border: `1px solid ${c.border}`, background: isDarkMode ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.02)", color: c.textPrimary, fontSize: "15px", fontFamily: "'Cairo', sans-serif", outline: "none", boxSizing: "border-box" }}
          />
        </div>

        {/* reason */}
        <div style={{ marginBottom: "24px" }}>
          <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "600", color: c.textSecondary, fontFamily: "'Cairo', sans-serif" }}>{t.workFromHome.reason}</label>
          <textarea value={wfhReason} onChange={(e) => setWfhReason(e.target.value)} placeholder={t.workFromHome.reasonPlaceholder} rows={4}
            style={{ width: "100%", padding: "14px 16px", borderRadius: "12px", border: `1px solid ${c.border}`, background: isDarkMode ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.02)", color: c.textPrimary, fontSize: "15px", fontFamily: "'Cairo', sans-serif", outline: "none", resize: "vertical", boxSizing: "border-box" }} />
        </div>

        {/* actions */}
        <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end" }}>
          <button onClick={onClose} disabled={isSubmittingWFH}
            style={{ padding: "14px 24px", borderRadius: "12px", border: `1px solid ${c.border}`, background: "transparent", color: c.textSecondary, fontSize: "15px", fontWeight: "600", fontFamily: "'Cairo', sans-serif", cursor: "pointer" }}>
            {t.workFromHome.cancel}
          </button>
          <button onClick={onSubmit} disabled={isSubmittingWFH || !wfhReason.trim()}
            style={{ padding: "14px 24px", borderRadius: "12px", border: "none", background: `linear-gradient(135deg,${c.primary},${c.primary}dd)`, color: "#fff", fontSize: "15px", fontWeight: "600", fontFamily: "'Cairo', sans-serif", cursor: isSubmittingWFH || !wfhReason.trim() ? "not-allowed" : "pointer", opacity: isSubmittingWFH || !wfhReason.trim() ? 0.6 : 1, display: "flex", alignItems: "center", gap: "8px" }}>
            {isSubmittingWFH
              ? <><div style={{ width: "16px", height: "16px", border: "2px solid rgba(255,255,255,0.3)", borderTopColor: "#fff", borderRadius: "50%", animation: "spin 0.8s linear infinite" }} />{t.workFromHome.submitting}</>
              : t.workFromHome.submit}
          </button>
        </div>
      </div>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
};

export default WFHModal;